import { render } from "./ApprovalThread.vue?vue&type=template&id=27b2fe54&scoped=true"
import script from "./ApprovalThread.vue?vue&type=script&lang=js"
export * from "./ApprovalThread.vue?vue&type=script&lang=js"

import "./ApprovalThread.vue?vue&type=style&index=0&id=27b2fe54&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27b2fe54"]])

export default __exports__